<template>
  <!-- 最新热点的nav -->
  <div style="overflow:hidden">
    <ul class="naviagate">
      <li @click="news" :class="navID=== 1 ? 'active':'deactive'">动态</li>
      <li class="click" :class="navID=== 2 ? 'active':'deactive'" @click="corp">合作</li>
      <li class="click" :class="navID=== 3 ? 'active':'deactive'" @click="act">活动</li>
      <li class="click" :class="navID=== 4 ? 'active':'deactive'" @click="experience">心得</li>
      <li class="click" :class="navID=== 5 ? 'active':'deactive'" @click="video" v-if="!isMiniProgram">视频</li>
    </ul>
    <div class="line"></div>
    <News :navID="navID" />
    <Cor :navID="navID" />
    <Act :navID="navID" />
    <Experience :navID="navID" />
    <!-- <Video :navID="navID" /> -->
  </div>
</template>

<script>
import News from "./News";
import Cor from "./Cor";
import Act from "./Act";
import Experience from "./Experience";
// import Video from "./VideoList";

export default {
  data() {
    return {
      navID: 1,
      isMiniProgram:false
    };
  },
  components: {
    News,
    Cor,
    Act,
    Experience,
    
  },
  mounted() {
    // document.documentElement.scrollTop || document.body.scrollTop;
    const userAgent = window.navigator.userAgent.toLowerCase()
    const isaMiniProgram = userAgent.includes('miniprogram')
    if (isaMiniProgram) this.isMiniProgram = true
  },
  methods: {
    news() {
      this.navID = 1;
      this.$emit("postID", this.navID);
    },
    corp() {
      this.navID = 2;
      this.$emit("postID", this.navID);
    },
    act() {
      this.navID = 3;
      this.$emit("postID", this.navID);
    },

    experience() {
      this.navID = 4;
      this.$emit("postID", this.navID);
    },
    video() {
      this.navID = 5;
      this.$router.push({ path: `/videoList.html` });
      // this.$router.replace('/videoList.html')
    }
  }
};
</script>

<style scoped>
.naviagate {
  padding-left: 30px;
  margin-top: 42px;
  margin-bottom: 28px;
  /* width: 660px; */
  /* margin: 42px auto 28px; */
  overflow: hidden;

}
.active {
  color: #0084ff !important;
}
.deactive {
  color: #282828 !important;
}
.naviagate li {
  float: left;
  font-size: 30px;
  color: #282828;
  font-weight: bold;
}
/* .naviagate li:hover {
  color: #0084ff;
} */
.click {
  margin-left: 90px;
}
.naviagate .line {
  margin-bottom: 34px;
}
</style>



// WEBPACK FOOTER //
// src/components/navigation/Nav.vue